import React from 'react'

import logo from '../../assets/img/2.png'

const DefaultImage = () => (
  <div className='default-image'>
    <img src={logo}  alt='Sem imagem' style={{ width: '100%' }} />
  </div>
)

export default DefaultImage